import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditTeacherComp from "./Component/EditTeacherComp"


const EditTeacher =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditTeacherComp />
            
        </div>
        <Footer />
        </>
    )
}

export default EditTeacher